<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;" id="contact-information">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Libellé de l'expéditeur</p>
        <p class="no-margin dark-gray">Nom affiché comme expéditeur des emails envoyés aux électeurs.</p>
      </div>
    </div>
  </div>

  <div id="sending-mode" class="p-20">
    <p class="dark-blue bold no-margin mb-10">Libellé de l'expéditeur</p>
    <div class="mb-20">

      <input type="text" name="sender-name" id="sender-name" class="w-quarter text-md dark-blue pap-input"
        [(ngModel)]="sender" (ngModelChange)="senderChange.emit($event)">
      <!-- [(ngModel)]=" application.challenge" (ngModelChange)="onApplicationChange()" -->

    </div>
    <div class="bg-pastel-blue radius-10" style="border: solid 1px #C3DAFD;">
      <p class="dark-blue no-margin p-20"><span class="bold">Important :</span> pour éviter le blocage de votre compte,
        sachez qu’il est interdit d’utiliser des noms de marque
        en tant qu’expéditeur : Apple, Samsung, Orange...</p>
    </div>

    <div class="w-half">
      <p class="bold dark-blue mb-10 text-sm">Logo de l'organisation syndicale</p>
      <div class="flex gap-20 align-items-center p-20 radius-10 pointer" (click)="fileInput1.click()"
        style="border: dotted 1px #1990FF; flex: 1;" (onFileDropped)="onFileChanged($event)">
        <img id="uploaded" class="none" src="" width="20px">
        <img id="upload-image-icon" src="assets/upload-icon.svg" width="20px">
        <div>
          <p class="light-blue no-margin no-margin"><span class="bold">Cliquez</span> pour importer une image</p>
          <input style="display: none" type="file" accept=".jpg,.jpeg,.png"
            (change)="onFileChanged($event.target.files); fileInput1.value=''" #fileInput1>
          <p class="grey no-margin text-sm">Format accepté : JPG, JPEG, PNG d'une taille maximale de 2 Mo.</p>
        </div>
      </div>
    </div>
  </div>
</div>